// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29hbU","type":"styles_type__hmIz5","choices":"styles_choices__2UF2r"};